"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroundPlane = void 0;
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const viewer_shared_types_1 = require("@shapediver/viewer.shared.types");
const THREE = __importStar(require("three"));
const SDData_1 = require("../../objects/SDData");
class GroundPlane {
    // #endregion Properties (4)
    // #region Constructors (1)
    constructor(_renderingEngine, _parent) {
        this._renderingEngine = _renderingEngine;
        this._parent = _parent;
        // #region Properties (4)
        this._converter = viewer_shared_services_1.Converter.instance;
        this._color = "#d3d3d3ff";
        this._groundPlaneObject = new SDData_1.SDData("groundPlane", "");
        const mat = new viewer_shared_types_1.MaterialStandardData();
        mat.color = this._color;
        mat.side = viewer_shared_types_1.MATERIAL_SIDE.FRONT;
        mat.opacity = this._converter.toAlpha(this._color);
        mat.roughness = 1;
        mat.metalness = 0;
        this._groundPlane = new THREE.Mesh(new THREE.PlaneGeometry(), this._renderingEngine.materialLoader.load(mat));
        this._groundPlane.receiveShadow = true;
        this._groundPlane.visible = false;
        this._groundPlaneObject.add(this._groundPlane);
        this._parent.add(this._groundPlaneObject);
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (4)
    get color() {
        return this._color;
    }
    set color(value) {
        this._color = value;
        this.assignGroundPlaneColor(value);
    }
    get visible() {
        return this._groundPlane.visible;
    }
    set visible(value) {
        this._groundPlane.visible = value;
    }
    // #endregion Public Getters And Setters (4)
    // #region Public Methods (2)
    changeSceneExtents(position, divisions, gridExtents) {
        this._groundPlane.geometry = new THREE.PlaneGeometry(2 * gridExtents, 2 * gridExtents, 2, 2);
        this._groundPlane.position.set(position[0], position[1], position[2]);
    }
    updatePosition(position) {
        this._groundPlane.position.set(position[0], position[1], position[2]);
    }
    // #endregion Public Methods (2)
    // #region Private Methods (1)
    assignGroundPlaneColor(color) {
        this._groundPlane.material.opacity =
            this._converter.toAlpha(color);
        this._groundPlane.material.transparent =
            this._groundPlane.material.opacity !==
                1;
        this._groundPlane.material.depthWrite =
            !this._groundPlane.material
                .transparent;
        this._groundPlane.material.color =
            this._renderingEngine.createThreeJsColor(color);
        this._groundPlane.material.needsUpdate =
            true;
    }
}
exports.GroundPlane = GroundPlane;
//# sourceMappingURL=GroundPlane.js.map